import React from 'react'

const TooltipOverlay = (props) => {
  const {
    title,
    placement = "top",
    style,
    className = "",
    fixed = false,
    interactive = false,
    tooltipStyle = {},
  } = props;
  const wrapperRef = React.useRef(null);
  const tooltipRef = React.useRef(null);
  const hideTimeoutRef = React.useRef(null);
  const [fixedStyle, setFixedStyle] = React.useState({});
  const [visible, setVisible] = React.useState(false);
  const [pinned, setPinned] = React.useState(false);

  React.useEffect(() => {
    if (!fixed || !interactive) return;

    const handleOutsideClick = (event) => {
      if (
        wrapperRef.current?.contains(event.target) ||
        tooltipRef.current?.contains(event.target)
      ) {
        return;
      }

      setPinned(false);
      setVisible(false);
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, [fixed, interactive]);

  const updateFixedPosition = () => {
    if (!fixed || !wrapperRef.current) return;

    const rect = wrapperRef.current.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const offset = 8;

    const positions = {
      top: {
        top: rect.top - offset,
        left: centerX,
        transform: "translate(-50%, -100%)",
      },
      bottom: {
        top: rect.bottom + offset,
        left: centerX,
        transform: "translate(-50%, 0)",
      },
      left: {
        top: centerY,
        left: rect.left - offset,
        transform: "translate(-100%, -50%)",
      },
      right: {
        top: centerY,
        left: rect.right + offset,
        transform: "translate(0, -50%)",
      },
    };

    setFixedStyle(positions[placement] ?? positions.top);
  };

  const showFixedTooltip = () => {
    if (!fixed) return;
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    updateFixedPosition();
    setVisible(true);
  };

  const scheduleHideFixedTooltip = () => {
    if (!fixed || pinned) return;
    hideTimeoutRef.current = setTimeout(() => {
      setVisible(false);
    }, interactive ? 150 : 0);
  };

  const handleWrapperClick = () => {
    if (!fixed || !interactive) return;
    updateFixedPosition();
    setPinned(true);
    setVisible(true);
  };

  return (
    <div
      ref={wrapperRef}
      className={`tooltip-wrapper ${fixed ? "" : `tooltip-wrapper--${placement}`} ${className}`}
      style={{ display: 'inline-block', ...style }}
      onMouseEnter={fixed ? showFixedTooltip : updateFixedPosition}
      onMouseLeave={scheduleHideFixedTooltip}
      onFocus={fixed ? showFixedTooltip : updateFixedPosition}
      onClick={handleWrapperClick}
    >
      {props.children}
      <span
        ref={tooltipRef}
        className="tooltip-content"
        onMouseEnter={fixed ? showFixedTooltip : undefined}
        onMouseLeave={scheduleHideFixedTooltip}
        style={{
          ...(fixed
            ? {
                position: "fixed",
                bottom: "auto",
                right: "auto",
                zIndex: 100000000,
                opacity: visible ? 1 : 0,
                visibility: visible ? "visible" : "hidden",
                pointerEvents: interactive ? "auto" : "none",
                userSelect: interactive ? "text" : "none",
                ...fixedStyle,
              }
            : {}),
          ...tooltipStyle,
        }}
      >
        {title}
      </span>
    </div>
  )
}

export default TooltipOverlay
